// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileProtectOutlinedSvg from "@fishx/icons-svg/es/asn/FileProtectOutlined";
import FishxIcon from '../components/FishxIcon';

var FileProtectOutlined = function FileProtectOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileProtectOutlinedSvg
  }));
};

FileProtectOutlined.displayName = 'FileProtectOutlined';
export default React.forwardRef(FileProtectOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileProtectOutlined.js
// module id = 2735
// module chunks = 0